function handleDrawerMenu() {
  const hamburgerMenu = document.getElementById("header-new__menu-icon");
  const menuDrawerNav = document.getElementById("menu-drawer-nav");
  const closeMenuDrawer = document.getElementById("menu-drawer-close");
  const headerNewInner = document.querySelector(".header-new__inner");

  if (!hamburgerMenu || !menuDrawerNav || !closeMenuDrawer || !headerNewInner)
    return;

  // Click to open menu drawer
  hamburgerMenu.addEventListener("click", () => {
    menuDrawerNav.classList.toggle("hide-this");
    // If menu drawer is open, set the header new inner to the width of the menu drawer
    if (!menuDrawerNav.classList.contains("hide-this")) {
      headerNewInner.style.transform = `translateX(${menuDrawerNav.clientWidth}px)`;
      menuDrawerNav.style.transform = "translateX(0)";
    } else {
      headerNewInner.style.transform = "translateX(0)";
      menuDrawerNav.style.transform = "translateX(-100%)";
    }
  });

  // Click to close menu drawer
  closeMenuDrawer.addEventListener("click", () => {
    menuDrawerNav.classList.add("hide-this");
    headerNewInner.style.transform = "translateX(0)";
  });

  // Click outside of menu drawer to close
  document.addEventListener("click", (e) => {
    if (
      !menuDrawerNav.contains(e.target) &&
      !hamburgerMenu.contains(e.target)
    ) {
      menuDrawerNav.classList.add("hide-this");
      headerNewInner.style.transform = "translateX(0)";
    }
  });

  // Escape key to close menu drawer
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      menuDrawerNav.classList.add("hide-this");
      headerNewInner.style.transform = "translateX(0)";
    }
  });
}

function closeOtherAccordions() {
  const menuDetails = document.querySelectorAll("details.menu-details");

  if (!menuDetails.length) return;

  menuDetails.forEach((detail) => {
    detail.addEventListener("toggle", () => {
      // Only run this code when a details element is being opened
      if (detail.open) {
        const level = detail.classList.contains("level-1")
          ? "level-1"
          : detail.classList.contains("level-2")
            ? "level-2"
            : "level-3";

        // Find all other details at the same level that are currently open
        const siblingDetails = document.querySelectorAll(
          `details.menu-details.${level}`,
        );

        siblingDetails.forEach((sibling) => {
          // Don't close the detail that was just opened
          if (sibling !== detail && sibling.open) {
            sibling.open = false;
          }
        });
      }
    });
  });
}

function stickDrawerMenuUnderAnnouncementBar() {
  const announcementBar = getPrimaryAnnouncementElement();
  const menuDrawerNav = document.getElementById("menu-drawer-nav");

  if (!announcementBar || !menuDrawerNav) return;

  const announcementBarHeight = announcementBar.offsetHeight;
  const currentDeviceWidth = getCurrentDeviceWidth();

  if (currentDeviceWidth <= 768) {
    menuDrawerNav.style.top = `${announcementBarHeight - 3}px`;
    menuDrawerNav.style.height = `calc(100vh - ${announcementBarHeight}px)`;
    menuDrawerNav.style.maxHeight = `calc(100vh - ${announcementBarHeight}px)`;
  } else {
    const topPosition = Math.max(0, announcementBarHeight);
    menuDrawerNav.style.top = `${topPosition}px`;

    const availableHeight = window.innerHeight - topPosition;
    menuDrawerNav.style.height = `${availableHeight}px`;
    menuDrawerNav.style.maxHeight = `${availableHeight}px`;
  }
}

function stickAlwaysUnderAnnouncementBarWhenSroll() {
  const announcementBar = getPrimaryAnnouncementElement();
  const menuDrawerNav = document.getElementById("menu-drawer-nav");

  if (!announcementBar || !menuDrawerNav) return;

  const announcementBarHeight = announcementBar.clientHeight;
  const scrollPosition = window.scrollY;

  // Calculate the top position
  const topPosition = Math.max(0, announcementBarHeight - scrollPosition);
  menuDrawerNav.style.top = `${topPosition}px`;

  // Calculate the available height for the drawer
  const availableHeight = window.innerHeight - topPosition;
  menuDrawerNav.style.height = `${availableHeight}px`;
  menuDrawerNav.style.maxHeight = `${availableHeight}px`;

  // If in mobile device the top -5
  if (getCurrentDeviceWidth() <= 768) {
    menuDrawerNav.style.top = `${topPosition - 5}px`;
  }
}

function getCurrentDeviceWidth() {
  return window.innerWidth;
}

function getPrimaryAnnouncementElement() {
  return (
    document.querySelector(".ombraz-abtest-announcement") ||
    document.querySelector("#shopify-section-announcement-bar") ||
    document.querySelector(".announcement-bar")
  );
}

function getMainContentFirstSection() {
  const mainContent = document.getElementById("MainContent");
  if (!mainContent) return null;

  const nonContentTags = ["SCRIPT", "STYLE", "TEMPLATE", "LINK", "NOSCRIPT", "META"];

  return (
    Array.from(mainContent.children).find(
      (child) =>
        !nonContentTags.includes(child.tagName) &&
        !child.hasAttribute("hidden"),
    ) || null
  );
}

function shouldEnableOverlayHeader() {
  if (document.body?.dataset?.currentTemplate === "index") {
    return true;
  }

  const firstMainSection = getMainContentFirstSection();
  if (!firstMainSection) return false;

  return (
    firstMainSection.matches?.('[data-overlay-hero="true"]') ||
    Boolean(firstMainSection.querySelector?.('[data-overlay-hero="true"]'))
  );
}

let hasInitializedHeaderOverlayAutoFit = false;
function initHeaderOverlayAutoFit() {
  const body = document.body;
  const root = document.documentElement;
  const headerNew = document.querySelector(".header-new");

  if (!body || !root || !headerNew || hasInitializedHeaderOverlayAutoFit) return;
  hasInitializedHeaderOverlayAutoFit = true;

  const getVisibleHeight = (element) => {
    if (!element) return 0;

    const styles = window.getComputedStyle(element);
    if (styles.display === "none" || styles.visibility === "hidden") {
      return 0;
    }

    return Math.max(0, Math.round(element.getBoundingClientRect().height));
  };

  const lastApplied = {
    announcementHeight: null,
    headerHeight: null,
    stackHeight: null,
    hasOverlayHeader: null,
  };

  let rafId = null;
  const applyOverlayLayout = () => {
    const announcementHeight = getVisibleHeight(getPrimaryAnnouncementElement());
    const headerHeight = getVisibleHeight(headerNew);
    const stackHeight = announcementHeight + headerHeight;

    if (lastApplied.announcementHeight !== announcementHeight) {
      root.style.setProperty("--ob-announcement-h", `${announcementHeight}px`);
      lastApplied.announcementHeight = announcementHeight;
    }

    if (lastApplied.headerHeight !== headerHeight) {
      root.style.setProperty("--ob-header-h", `${headerHeight}px`);
      lastApplied.headerHeight = headerHeight;
    }

    if (lastApplied.stackHeight !== stackHeight) {
      root.style.setProperty("--ob-header-stack-h", `${stackHeight}px`);
      lastApplied.stackHeight = stackHeight;
    }

    const shouldEnableOverlay = shouldEnableOverlayHeader();
    if (lastApplied.hasOverlayHeader !== shouldEnableOverlay) {
      body.classList.toggle("has-overlay-header", shouldEnableOverlay);
      lastApplied.hasOverlayHeader = shouldEnableOverlay;
    }
  };

  const scheduleOverlayLayout = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      applyOverlayLayout();
    });
  };

  applyOverlayLayout();

  window.addEventListener("resize", scheduleOverlayLayout, { passive: true });
  window.addEventListener("orientationchange", scheduleOverlayLayout, {
    passive: true,
  });
  window.addEventListener("load", scheduleOverlayLayout);

  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(scheduleOverlayLayout);
    resizeObserver.observe(headerNew);

    const announcementElement = getPrimaryAnnouncementElement();
    if (announcementElement) {
      resizeObserver.observe(announcementElement);
    }
  }

  const mutationObserver = new MutationObserver(scheduleOverlayLayout);
  const mainContent = document.getElementById("MainContent");
  if (mainContent) {
    mutationObserver.observe(mainContent, {
      childList: true,
      subtree: false,
    });
  }

  const announcementElement = getPrimaryAnnouncementElement();
  if (announcementElement) {
    mutationObserver.observe(announcementElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  }
}

function initMenuDrawerSearch() {
  const form = document.querySelector("[data-menu-drawer-search]");
  const input = form?.querySelector('input[name="q"]');

  if (!form || !input) return;

  form.addEventListener("submit", (event) => {
    const term = input.value.trim();

    if (!term) {
      event.preventDefault();
      return;
    }

    const normalizedTerm = normalizeSearchTerm(term);
    if (normalizedTerm !== term) input.value = normalizedTerm;
  });
}

function normalizeSearchTerm(term) {
  return term
    .trim()
    .replace(/\bnon[\s-]*polarized\b/gi, "non-polarized")
    .replace(/\bno\s+polarized\b/gi, "non-polarized")
    .replace(/\bnot\s+polarized\b/gi, "non-polarized");
}

let hasBootstrappedHeaderNew = false;
function bootstrapHeaderNew() {
  if (hasBootstrappedHeaderNew) return;
  hasBootstrappedHeaderNew = true;

  initHeaderOverlayAutoFit();
  handleDrawerMenu();
  closeOtherAccordions();
  stickDrawerMenuUnderAnnouncementBar();
  initMenuDrawerSearch();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrapHeaderNew, { once: true });
} else {
  bootstrapHeaderNew();
}

window.addEventListener("scroll", () => {
  stickAlwaysUnderAnnouncementBarWhenSroll();
});

window.addEventListener("resize", () => {
  stickDrawerMenuUnderAnnouncementBar();
});
